import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const disconnectEnvironmentSensorAction = getApiActionCreator(actionTypes.DISCONNECT_ENVIRONMENT_SENSOR_SETTINGS);

export const disconnectEnvironmentSensor = (gatewayID) => {
    return {
        type: actionTypes.DISCONNECT_ENVIRONMENT_SENSOR,
        gatewayID
    };
};
